import _ from 'underscore';

export const generateAddOrEditGoalPayload = (goals) => {
  const result = goals.map((goal) => {
    const newPayloadGoal = { ...goal };

    delete newPayloadGoal.Domains;
    delete newPayloadGoal.PageUrls;

    newPayloadGoal.GoalValue = parseFloat(goal.GoalValue);

    if (newPayloadGoal.ValueOperator === 'NoValue') {
      delete newPayloadGoal.ValueOperator;
      delete newPayloadGoal.Value;
    }

    if (newPayloadGoal.LabelOperator === 'NoValue') {
      delete newPayloadGoal.LabelOperator;
      delete newPayloadGoal.Label;
    }

    if (newPayloadGoal.GoalValueType === 'NoValue') {
      delete newPayloadGoal.CurrencyCode;
      delete newPayloadGoal.GoalValue;
    } else {
      newPayloadGoal.GoalValue = (_.isUndefined(newPayloadGoal.GoalValue) || _.isNull(newPayloadGoal.GoalValue)) ? 1 : newPayloadGoal.GoalValue;
      newPayloadGoal.CurrencyCode = newPayloadGoal.CurrencyCode === null ? 'USD' : newPayloadGoal.CurrencyCode;
    }
    return {
      ...newPayloadGoal,
    };
  });
  return result;
};

